/* eslint-disable max-len */
const Warning = () => (
  <svg fill="none" height="72" viewBox="0 0 72 72" width="72" xmlns="http://www.w3.org/2000/svg">
    <path d="M63.7981 62.9943H8.19914C7.12736 62.9943 6.137 62.4225 5.60112 61.4943C5.06524 60.5661 5.06525 59.4225 5.60114 58.4943L33.3991 10.4943C33.9355 9.56768 34.925 8.99707 35.9956 8.99707C37.0663 8.99707 38.0558 9.56768 38.5921 10.4943L66.3901 58.4943C66.9258 59.4221 66.9261 60.565 66.3909 61.493C65.8558 62.421 64.8664 62.9932 63.7951 62.9943H63.7981ZM36.0001 17.9943L13.4071 56.9943H58.5991L36.0001 17.9943ZM38.9851 44.9973H32.9851V29.9943H38.9851V44.9973Z" fill="#631FFE" />
    <path d="M33.0001 48.0003H39.0001V54.0003H33.0001V48.0003Z" fill="#631FFE" />
  </svg>
);

export default Warning;
